import { environment } from './lib/environments/win-web/environment';
import { project } from './lib/project/project';

export { SystemKeys } from './lib/const/system-keys';
export { CountryCodesUtilities } from './lib/const/country-codes-utility';
export { MfeRouteModel, FederationType } from './lib/interface/mfe-route.interface';
export { getNativeRemoteEntry } from './lib/interface/native-federation.util';
export { RumConfig } from './lib/interface/environment.interface';
export { ProjectConfig } from './lib/interface/project.interface';

export const BASE_URL = environment.mobileApiPath;
export const AMS_GATEWAY_PATH = '/ams-gateway';
export const ENVIRONMENT = environment;
export const PROJECT = project;
export const IS_LOCALHOST: boolean = location.host.indexOf('localhost') > -1;
export const LIVE_ENVIRONMENT: boolean = environment.prod || environment.staging || environment.uat || environment.sit;
